export default __webpack_public_path__ + "static/media/img-3.7a525ae4.png";